var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-statements */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';

import { useLoaderData, useRevalidator } from 'react-router-dom';

import { useSetAtom, useAtomValue } from 'jotai';
import { Translate } from "../../../../I18N";
import * as relationshipTypesAPI from "../../../api/relationshiptypes";

import { notificationAtom, templatesAtom } from "../../../atoms";
import { relationshipTypesAtom } from "../../../atoms/relationshipTypes";
import { Button, Table, Sidepanel, ConfirmationModal } from "../../../Components/UI";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import { columns } from "./components/TableComponents";
import { Form } from "./components/Form";

const relationshipTypesLoader =
(headers) =>
async () =>
relationshipTypesAPI.get(headers);

const RelationshipTypes = () => {
  const relationshipTypes = useLoaderData();
  const revalidator = useRevalidator();

  const [isSidepanelOpen, setIsSidepanelOpen] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const setNotifications = useSetAtom(notificationAtom);
  const setRelationshipTypes = useSetAtom(relationshipTypesAtom);
  const templates = useAtomValue(templatesAtom);




  const [formValues, setFormValues] = useState({});

  const [selectedItems, setSelectedItems] = useState([]);
  const [tableRelationshipTypes, setTableRelationshipTypes] = useState([]);

  useEffect(() => {
    setTableRelationshipTypes(
      relationshipTypes.map((relationshipType) => {
        const templatesUsingIt = templates.
        map((t) => {var _t$properties;
          const usingIt = (_t$properties = t.properties) === null || _t$properties === void 0 ? void 0 : _t$properties.some(
            (property) => property.relationType === relationshipType._id
          );
          return usingIt ? t : null;
        }).
        filter((t) => t);

        return _objectSpread(_objectSpread({},
        relationshipType), {}, {
          templates: templatesUsingIt,
          disableRowSelection: Boolean(templatesUsingIt.length) });

      })
    );
  }, [relationshipTypes, templates]);

  const edit = (row) => {
    setFormValues(row.original);
    setIsSidepanelOpen(true);
  };

  const add = () => {
    setFormValues({ name: '' });
    setIsSidepanelOpen(true);
  };

  const submit = async (submitedData) => {
    try {
      await relationshipTypesAPI.save(submitedData);
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Updated")
      });
      setIsSidepanelOpen(false);
    } catch (error) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: error.error
      });
      setIsSidepanelOpen(false);
    }
    revalidator.revalidate();
    setRelationshipTypes(relationshipTypes);
  };

  const deleteSelected = async () => {
    try {
      await relationshipTypesAPI.deleteRelationtypes(selectedItems.map((item) => item.original._id));
      setNotifications({
        type: 'success',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "Updated")
      });
      setShowConfirmationModal(false);
    } catch (error) {
      setNotifications({
        type: 'error',
        text: /*#__PURE__*/_jsx(Translate, {}, void 0, "An error occurred"),
        details: error.error
      });
      setShowConfirmationModal(false);
    }
    revalidator.revalidate();
    setRelationshipTypes(relationshipTypes);
  };

  return /*#__PURE__*/(
    _jsx("div", { className: "tw-content", style: { width: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Relationship types" }), /*#__PURE__*/
    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Table, {
      enableSelection: true,
      columns: columns({ edit }),
      data: tableRelationshipTypes,
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Relationship types"),
      onSelection: setSelectedItems }
    )
    ), /*#__PURE__*/
    _jsx(SettingsContent.Footer, { className: selectedItems.length ? 'bg-primary-50' : '' }, void 0,
    selectedItems.length > 0 && /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 items-center" }, void 0, /*#__PURE__*/
    _jsx(Button, {
      type: "button",
      onClick: () => setShowConfirmationModal(true),
      color: "error",
      "data-testid": "relationship-types-delete" }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    ), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Selected"), " ", selectedItems.length, " ", /*#__PURE__*/_jsx(Translate, {}, void 0, "of"),
    relationshipTypes.length
    ),

    selectedItems.length === 0 && /*#__PURE__*/
    _jsx("div", { className: "flex justify-between w-full" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { type: "button", onClick: add, "data-testid": "relationship-types-add" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add relationship type")
    )
    )
    )

    )
    ), /*#__PURE__*/
    _jsx(Sidepanel, {
      title: /*#__PURE__*/
      _jsx(Translate, { className: "uppercase" }, void 0,
      `${(formValues === null || formValues === void 0 ? void 0 : formValues.name) === '' ? 'Add' : 'Edit'} relationship type`
      ),

      isOpen: isSidepanelOpen,
      closeSidepanelFunction: () => setIsSidepanelOpen(false),
      size: "medium",
      withOverlay: true }, void 0, /*#__PURE__*/

    _jsx(Form, {
      relationtype: formValues,
      closePanel: () => setIsSidepanelOpen(false),
      currentTypes: relationshipTypes,
      submit: submit }
    )
    ),
    showConfirmationModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      size: "lg",
      header: /*#__PURE__*/_jsx(Translate, {}, void 0, "Delete"),
      warningText: /*#__PURE__*/_jsx(Translate, {}, void 0, "Do you want to delete the following items?"),
      body: /*#__PURE__*/
      _jsx("ul", { className: "flex flex-wrap gap-8 max-w-md list-disc list-inside" }, void 0,
      selectedItems.map((item) => /*#__PURE__*/
      _jsx("li", {}, item.original.name, item.original.name)
      )
      ),

      onAcceptClick: deleteSelected,
      onCancelClick: () => setShowConfirmationModal(false),
      dangerStyle: true }
    )

    ));

};

export { RelationshipTypes, relationshipTypesLoader };